<template>
  <button v-if="showBack" class="kiosk-back" @click="goBack" aria-label="Indietro">
    <span class="kiosk-back__chevron">‹</span> Indietro
  </button>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

// Pagine che hanno GIÀ un proprio tasto "Torna indietro": lì non mostriamo il
// tasto globale, per evitare due frecce sovrapposte in alto a sinistra.
const HAS_OWN_BACK = ['/checkout', '/services-flow', '/register', '/verify', '/kiosk-admin', '/kiosk-wait']

// La home del kiosk è la radice: lì non c'è "indietro".
const showBack = computed(() =>
  route.path !== '/kiosk' &&
  route.path !== '/' &&
  !HAS_OWN_BACK.some((p) => route.path.startsWith(p)))

// Pagine da cui "indietro" torna alla HOME invece di router.back(): sono pagine
// di autenticazione/esito dove tornare indietro rifarebbe scattare un redirect
// (es. una rotta protetta rimanda di nuovo a /login → si resterebbe bloccati).
const HOME_ON_BACK = ['/login', '/register', '/password-reset', '/success', '/verify']

function goBack () {
  if (HOME_ON_BACK.some((p) => route.path.startsWith(p))) {
    router.push({ path: '/kiosk' })
    return
  }
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push({ path: '/kiosk' })
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@600&display=swap');

.kiosk-back {
  position: fixed;
  top: 18px;
  left: 18px;
  z-index: 9998;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 12px 22px;
  font-family: 'Montserrat', sans-serif;
  font-size: 1.15rem;
  font-weight: 600;
  cursor: pointer;
}
.kiosk-back:active { background: rgba(255, 255, 255, 0.28); }
.kiosk-back__chevron { font-size: 1.5rem; line-height: 1; }
</style>
